import { render, staticRenderFns } from "./FollowUpCommunication.vue?vue&type=template&id=7ef0578e&"
import script from "./FollowUpCommunication.vue?vue&type=script&lang=js&"
export * from "./FollowUpCommunication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports